(function () {
  'use strict';

  const SETTINGS_SELECTOR = '[data-show-sold-out-button]';
  const SOLD_OUT_SELECTOR = '.product-form__add-btn';
  const KLAVIYO_SELECTOR = '#klaviyo-bis-button-container';

  function updateButtons(settingsWrapper) {
    const showSoldOut =
      settingsWrapper.dataset.showSoldOutButton === 'true';

    const productForm = settingsWrapper.querySelector(
      'form.product-form'
    );

    if (!productForm) return;

    const soldOutButton = productForm.querySelector(
      SOLD_OUT_SELECTOR
    );

    if (!soldOutButton) return;

    const addContainer = soldOutButton.closest(
      '.product-form__add'
    );

    const isSoldOut =
      soldOutButton.disabled ||
      Boolean(addContainer?.classList.contains('is-disabled'));

    if (!isSoldOut) return;

    const section =
      settingsWrapper.closest('.shopify-section') ||
      settingsWrapper.parentElement;

    const klaviyoButton = section?.querySelector(KLAVIYO_SELECTOR);

    /*
     * Apply styles only when they need changing.
     * This avoids repeatedly triggering the observer.
     */

    function setDisplay(element, value) {
      if (!element) return;

      if (element.style.getPropertyValue('display') !== value ||
          element.style.getPropertyPriority('display') !== 'important') {
        element.style.setProperty('display', value, 'important');
      }
    }

    if (showSoldOut) {
      setDisplay(soldOutButton, 'block');
      setDisplay(klaviyoButton, 'none');

      // Keep the Sold Out button disabled.
      if (!soldOutButton.disabled) {
        soldOutButton.disabled = true;
      }
    } else {
      setDisplay(soldOutButton, 'none');
      setDisplay(klaviyoButton, 'block');
    }
  }

  function updateAllButtons() {
    document.querySelectorAll(SETTINGS_SELECTOR).forEach(updateButtons);
  }

  function init() {
    updateAllButtons();

    /*
     * Observe DOM and relevant attribute changes.
     * Ignore our own style changes to prevent observer loops.
     */
    const observer = new MutationObserver(function (mutations) {
      let shouldUpdate = false;

      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          shouldUpdate = true;
          break;
        }

        if (
          mutation.type === 'attributes' &&
          mutation.attributeName !== 'style'
        ) {
          shouldUpdate = true;
          break;
        }
      }

      if (shouldUpdate) {
        updateAllButtons();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'data-show-sold-out-button']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();